import '../styles/hero.css';

const Hero = () => {
    return (
        <section id="home" className="hero">
            <div className="hero-content">
                <div className="hero-text" role="heading" aria-level="1">
                    <h1>Software</h1>
                    <h1>Engineer<span className="accent">.</span></h1>
                    <p className="subtitle">Crafting digital experiences with clean, efficient code</p>
                </div>
                <div className="scroll-indicator animate-bounce">
                    <span aria-hidden="true">Scroll Down</span>
                    <div className="mouse" aria-label="Scroll down indicator"></div>
                </div>
            </div>
        </section>
    )
}

export default Hero;